import HTable from './HTable';

export default HTable;


// WEBPACK FOOTER //
// ./resources/assets/js/components/HTable/index.js